import React from 'react';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import {
  FDBackButton, FDPrimaryActionButton, FDStack,
} from '@facet-wealth/design';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { dataAttrs } from 'Helpers/Testing';
import { FDInputRow } from 'Packages/FacetDesign/Components/Experimental/fdInputRow';

export const DetailContent = () => {
  const {
    resource, onSubmit, saving, handleChange,
  } = useMetaLayoutContext();

  return (
    <FDStack direction={'column'} spacing={8}>
      <FDStack direction={'column'} spacing={4}>
        <MetaControlField attr={'detailTitle'} />
        <MetaControlField attr={'detailDescription'} />
        <FDInputRow>
          <MetaControlField attr={'firstName'} />
          <MetaControlField attr={'lastName'} />
          <MetaControlField attr={'phoneNumber'} />
          <MetaControlField attr={'emailAddress'} />
        </FDInputRow>

        <FDInputRow>
          <MetaControlField attr={'addressLine1'} />
          <MetaControlField attr={'addressLine2'} />
          <MetaControlField attr={'city'} />
          <MetaControlField attr={'state'} />
          <MetaControlField attr={'zipCode'} />
        </FDInputRow>
      </FDStack>

      <FDStack alignItems={'center'} spacing={2} justifyContent={'center'}>
        <FDBackButton
          {...dataAttrs('back-btn', resource)}
          size={'md'}
          label={resource.attr('detailSecondaryActionLabel')}
          onClick={() => handleChange('hasTrustedContact', 'false')}
        />
        {resource.meta().canSubmit() ? <FDPrimaryActionButton
          size={'md'}
          {...dataAttrs('continue-btn', resource)}
          loading={saving}
          label={resource.attr('detailPrimaryActionLabel')}
          onClick={() => onSubmit()}
        /> : null}
      </FDStack>
    </FDStack>
  );
};
